import styled from 'styled-components';
import { P } from '@components/Typography';

export const DescriptionText = styled(P)<{
  color?: string;
}>`
  color: ${props => props.color ?? props.theme.color.primaryText};
`;
